import { IMobileTopMenuData, IMobileTopMenuTab } from '../interfaces';
import { getJSONFromHtml } from '../../../../domain/common';
import { getPersonalizationProperty } from '../../../personalization/domain/personalization-provider';

export const getSelectedTab = (data?: IMobileTopMenuData, selectedTabId?: string|null) : IMobileTopMenuTab|undefined|null => {
    if(!data || !selectedTabId) return null;
    return data?.topMenu?.find(tab => tab.id === selectedTabId);
};

export const getMobileMenuData = () : IMobileTopMenuData => {
    // const userHasSubscription = getHiddenDataBoolean('user-has-active-wca');
    const userHasSubscription = getPersonalizationProperty('hasActiveWCA') as boolean;
    const data = getJSONFromHtml(document.getElementById('site-header-top-menu-m-json')) as IMobileTopMenuData;

    for(const item of data.topMenu) {
        if(item.id !== 'products') continue;

        for(const section of item.sections) {
            if(section.type !== 'topLink') continue;

            for(const sectionItem of section.sectionItems) {

                if(sectionItem.type === 'before') {
                    sectionItem.hidden = userHasSubscription;
                }

                if(sectionItem.type === 'beforeOlm') {
                    sectionItem.hidden = !userHasSubscription;
                }
            }
        }
    }

    return data;
};